import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPPlayer from "../SPPlayer";

export default class QuantumJump extends SPAbility {
    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 20,
            duration: 0,
            icon: 11,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onUse(): void {
        this.player.transform.position = this.player.engine.mouseWorldPosition.clone();
    }
}